export const goDefaultSource = `package main

import (
	"fmt"
	"errors"
)

func main() {
	// These fmt calls will be matched and replaced
	fmt.Println("Hello, World!")
	fmt.Printf("User %s logged in\n", "john")
	
	name := "Alice"
	age := 30
	fmt.Println("User info:", name, age)
	
	if err := doSomething(); err != nil {
		fmt.Printf("Error occurred: %v\n", err)
	}
	
	// This should not be matched (string literal)
	message := "fmt.Println should not match this"
	
	// This should be matched
	fmt.Println("Processing complete")
}

func doSomething() error {
	fmt.Printf("Starting operation at %s\n", "now")
	return errors.New("something went wrong")
}`;

export const goDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";
import type Go from "@ast-grep/napi/lang/go";

async function transform(root: SgRoot<Go>): Promise<string> {
  const rootNode = root.root();

  // Find all fmt.Println calls
  const printlnNodes = rootNode.findAll({
    rule: {
      kind: "call_expression",
      has: {
        field: "function",
        all: [
          {
            has: {
              field: "operand",
              regex: "^fmt$"
            }
          },
          {
            has: {
              field: "field",
              regex: "^Println$"
            }
          }
        ]
      }
    },
  });

  // Find all fmt.Printf calls
  const printfNodes = rootNode.findAll({
    rule: {
      kind: "call_expression",
      has: {
        field: "function",
        all: [
          {
            has: {
              field: "operand",
              regex: "^fmt$"
            }
          },
          {
            has: {
              field: "field",
              regex: "^Printf$"
            }
          }
        ]
      }
    },
  });

  const edits = [
    // Replace fmt.Println with log.Info
    ...printlnNodes.map(node => {
      const argsNode = node.field("arguments");
      if (argsNode && argsNode.children().length > 0) {
        const args = argsNode.children().map(child => child.text()).join(", ");
        return node.replace(\`log.Info("message", "args", []interface{}{\${args}})\`);
      }
      return node.replace('log.Info("message")');
    }),
    
    // Replace fmt.Printf with log.Infof  
    ...printfNodes.map(node => {
      const argsNode = node.field("arguments");
      if (argsNode && argsNode.children().length > 0) {
        const args = argsNode.children().map(child => child.text()).join(", ");
        return node.replace(\`log.Infof(\${args})\`);
      }
      return node.replace('log.Info("message")');
    })
  ];

  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const goDefaultConfig = `
# Codemod Studio uses ast-grep to match and rewrite code.
# https://ast-grep.github.io/guide/rule-config.html#rule
id: replace-fmt-with-logger
language: go
rule:
  any:
    - kind: call_expression
      has:
        field: function
        all:
          - has:
              field: operand
              regex: ^fmt$
          - has:
              field: field
              regex: ^Println$
    - kind: call_expression
      has:
        field: function
        all:
          - has:
              field: operand
              regex: ^fmt$
          - has:
              field: field
              regex: ^Printf$
fix: log.Info($$$)
`.trim();
